import React, { useEffect, useState } from 'react';
import {
    TextField,
    Checkbox,
    FormControlLabel,
    FormGroup,
    Button,
    Typography,
    Box,

} from '@mui/material';
import { useAppContext } from '../../contexts/AppContext';
import { API_BASE_URL } from '../../services/fetchData';
import { useAlerta } from '../../contexts/AlertaContext';

export default function Formulario() {
    const { userData, formularioRecorrido, login, loading } = useAppContext();
    const showAlerta = useAlerta();
    const [canEdit, setCanEdit] = useState(true);

    const [formulario, setFormulario] = useState({
        cuit: userData?.Representado?.RdoCuilCuit || userData?.CUIL || '',
        razonSocial: userData?.Representado?.RdoNombre || (userData?.Nombre && userData?.Apellido ? `${userData.Nombre} ${userData.Apellido}` : '') || '',
        nombreFantasia: '',
        formaJuridica: '',
        nombre: userData?.Nombre || '',
        apellido: userData?.Apellido || '',
        cuil: userData?.CUIL || '',
        telefono: userData?.CelFormateado || '',
        email: userData?.Email || '',
        rubro: '',
        ubicacion: {
            principal: '',
            secundario: '',
        },

        redesSociales: {
            instagram: '',
            facebook: '',
            otra: '',
        },
        logotipo: [],
        dimensiones: '',
        autoabastecimiento: '',
        cantidadEstimada: '',
        notaOferta: [],
        vehiculos: [],
        juegos: [],
        registral: [],
        arca: [],
        ingresosBrutos: [],
        tasaComercio: [],
        libreDeuda: [],
    });

    useEffect(() => {
        // Verificar si hay cookie CIDI (significa que está procesando autenticación)
        const hasCidiCookie = document.cookie.includes('CiDi=');
        
        // Redirigir a CIDI solo si NO hay cookie CIDI y no está logueado
        // Esperamos a que termine la verificación (loading === false) y si no hay userData, redirigimos
        if (!loading && !userData && !hasCidiCookie) {
            login();
        }
    }, [loading, userData, login]);

    useEffect(() => {
        if (formularioRecorrido) {
            setFormulario({
                cuit: formularioRecorrido.cuit,
                razonSocial: formularioRecorrido.razon_social,
                nombreFantasia: formularioRecorrido.nombre_fantasia,
                formaJuridica: formularioRecorrido.forma_juridica,
                nombre: formularioRecorrido.nombre,
                apellido: formularioRecorrido.apellido,
                cuil: formularioRecorrido.cuil,
                telefono: formularioRecorrido.telefono,
                email: formularioRecorrido.correo_electronico,
                rubro: formularioRecorrido.informacion_espacio,
                ubicacion: {
                    principal: formularioRecorrido.ubicacion_principal,
                    secundario: formularioRecorrido.ubicacion_secundaria,
                },

                redesSociales: {
                    instagram: formularioRecorrido.instagram,
                    facebook: formularioRecorrido.facebook,
                    otra: formularioRecorrido.otra_red_social,
                },
                logotipo: [formularioRecorrido.logotipos],
                dimensiones: formularioRecorrido.dimensiones,
                autoabastecimiento: formularioRecorrido.tipo_autoabastecimiento_energetico,
                cantidadEstimada: formularioRecorrido.cantidad_estimada_distribucion,
                notaOferta: [formularioRecorrido.nota_oferta_gastronomica],
                vehiculos: [formularioRecorrido.vehiculos_mobiliario],
                juegos: [formularioRecorrido.descripcion_juegos],
                registral: [formularioRecorrido.inscripcion_registral],
                arca: [formularioRecorrido.constancia_inscripcion_arca],
                ingresosBrutos: [formularioRecorrido.constancia_iibb_dgr],
                tasaComercio: [formularioRecorrido.tasa_comercio_municipal],
                libreDeuda: [formularioRecorrido.libre_deuda_municipalidad_vm],
            });
            setCanEdit(false);
            showAlerta('info', 'Usted ya completó el formulario, deberá esperar a que sea aprobado');
        }
    }, [formularioRecorrido]);

    const handleSubmit = async (e) => {
        e.preventDefault();



        const camposRequeridos = [
            { nombre: 'El nombre es', valor: formulario.nombre },
            { nombre: 'El apellido es', valor: formulario.apellido },
            { nombre: 'El cuil es', valor: formulario.cuil },
            { nombre: 'El teléfono es', valor: formulario.telefono },
            { nombre: 'El correo electrónico es', valor: formulario.email },
            { nombre: 'El cuit es', valor: formulario.cuit },
            { nombre: 'La razón social es', valor: formulario.razonSocial },
            { nombre: 'EL nombre de fantasía es', valor: formulario.nombreFantasia },
            { nombre: 'La forma jurídica es', valor: formulario.formaJuridica },
            { nombre: 'La información del espacio es', valor: formulario.rubro },
            { nombre: 'La ubicación principal es', valor: formulario.ubicacion.principal },
            { nombre: 'La ubicación secundaria es', valor: formulario.ubicacion.secundario },
            { nombre: 'El logotipo es', valor: formulario.logotipo[0] },
            { nombre: 'Las dimensiones son', valor: formulario.dimensiones },
            { nombre: 'El tipo de autoabastecimiento energético es', valor: formulario.autoabastecimiento },
            { nombre: 'La cantidad estimada de distribución es', valor: formulario.cantidadEstimada },
            { nombre: 'La constancia de inscripción en ARCA es', valor: formulario.arca[0] },
            { nombre: 'La constancia de ingresos brutos en DGR es', valor: formulario.ingresosBrutos[0] },
        ];

        for (let campo of camposRequeridos) {
            if (!campo.valor) {
                showAlerta('error', `${campo.nombre} requerido`);
                return;
            }
        }


        const formData = new FormData();


        formData.append('cuit', formulario.cuit);
        formData.append('razon_social', formulario.razonSocial);
        formData.append('nombre_fantasia', formulario.nombreFantasia);
        formData.append('forma_juridica', formulario.formaJuridica);
        formData.append('nombre', formulario.nombre);
        formData.append('apellido', formulario.apellido);
        formData.append('cuil', formulario.cuil);
        formData.append('telefono', formulario.telefono);
        formData.append('correo_electronico', formulario.email);
        formData.append('informacion_espacio', formulario.rubro);
        formData.append('ubicacion_principal', formulario.ubicacion.principal);
        formData.append('ubicacion_secundaria', formulario.ubicacion.secundario);
        formData.append('logotipos', formulario.logotipo[0]);
        formData.append('instagram', formulario.redesSociales.instagram);
        formData.append('facebook', formulario.redesSociales.facebook);
        formData.append('otra_red_social', formulario.redesSociales.otra);
        formData.append('dimensiones', formulario.dimensiones);
        formData.append('tipo_autoabastecimiento_energetico', formulario.autoabastecimiento);
        formData.append('cantidad_estimada_distribucion', formulario.cantidadEstimada);
        formData.append('nota_oferta_gastronomica', formulario.notaOferta[0]);
        formData.append('vehiculos_mobiliario', formulario.vehiculos[0]);
        formData.append('descripcion_juegos', formulario.juegos[0]);
        formData.append('inscripcion_registral', formulario.registral[0]);
        formData.append('constancia_inscripcion_arca', formulario.arca[0]);
        formData.append('constancia_iibb_dgr', formulario.ingresosBrutos[0]);
        formData.append('tasa_comercio_municipal', formulario.tasaComercio[0]);
        formData.append('libre_deuda_municipalidad_vm', formulario.libreDeuda[0]);




        let response = await fetch(`${API_BASE_URL}recorrido/`,
            {
                method: 'POST',


                body: formData,
            });

        if (response.ok) {
            showAlerta('success', 'Formulario enviado correctamente');
            setCanEdit(false);



        } else {
            showAlerta('error', 'Error al enviar el formulario');
        }
    }



    // Mostrar carga mientras se verifica la autenticación
    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
                <Typography variant="h6">Verificando autenticación...</Typography>
            </Box>
        );
    }

    // Mostrar mensaje si no tiene nivel 2
    if (userData && userData.Id_Estado === 1) {
        return <Typography variant="h6">Es necesario CIDI nivel 2 para completar el formulario</Typography>
    }

    // Si no hay userData y no está cargando, el useEffect ya debería haber redirigido
    if (!userData) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
                <Typography variant="h6">Redirigiendo a CIDI...</Typography>
            </Box>
        );
    }

    return (
        <Box component="form" sx={{
            display: 'flex', flexDirection: 'column', gap: 2, backgroundColor: 'rgba(255,255,255,0.1)',
            borderRadius: '8px',
            backdropFilter: 'blur(10px)',
            p: 3,
        }}>
            <Typography variant="h6">1. Datos de Contacto</Typography>
            <TextField label="Nombre*" value={formulario.nombre || ''} onChange={e => setFormulario({ ...formulario, nombre: e.target.value })} variant='outlined' />
            <TextField label="Apellido*" value={formulario.apellido || ''} onChange={e => setFormulario({ ...formulario, apellido: e.target.value })} />
            <TextField label="CUIL*" placeholder="XX-XXXXXXXX-X" value={formulario.cuil || ''} onChange={e => setFormulario({ ...formulario, cuil: e.target.value })} />
            <TextField label="Teléfono*" placeholder="Sin 0 y sin 15" value={formulario.telefono || ''} onChange={e => setFormulario({ ...formulario, telefono: e.target.value })} />
            <TextField label="Correo Electrónico*" placeholder="ejemplo@dominio.com" value={formulario.email || ''} onChange={e => setFormulario({ ...formulario, email: e.target.value })} />

            <Typography variant="h6">2. Información del Titular</Typography>
            <TextField label="CUIT*" placeholder="XX-XXXXXXXX-X"
                value={formulario.cuit || ''} onChange={e => setFormulario({ ...formulario, cuit: e.target.value })} />
            <TextField label="Razón Social*" value={formulario.razonSocial || ''} onChange={e => setFormulario({ ...formulario, razonSocial: e.target.value })} />
            <TextField label="Nombre de Fantasía*" inputProps={{ maxLength: 100 }} value={formulario.nombreFantasia} onChange={e => setFormulario({ ...formulario, nombreFantasia: e.target.value })} />
            <Typography variant="body1">Forma Jurídica*</Typography>
            <FormGroup>
                <FormControlLabel control={<Checkbox />} label="Unipersonal" checked={formulario.formaJuridica === 'Unipersonal'} onChange={e => setFormulario({ ...formulario, formaJuridica: e.target.checked ? 'Unipersonal' : '' })} />
                <FormControlLabel control={<Checkbox />} label="SRL" checked={formulario.formaJuridica === 'SRL'} onChange={e => setFormulario({ ...formulario, formaJuridica: e.target.checked ? 'SRL' : '' })} />
                <FormControlLabel control={<Checkbox />} label="SA" checked={formulario.formaJuridica === 'SA'} onChange={e => setFormulario({ ...formulario, formaJuridica: e.target.checked ? 'SA' : '' })} />
                <FormControlLabel control={<Checkbox />} label="SAS" checked={formulario.formaJuridica === 'SAS'} onChange={e => setFormulario({ ...formulario, formaJuridica: e.target.checked ? 'SAS' : '' })} />
                <FormControlLabel control={<Checkbox />} label="Cooperativa" checked={formulario.formaJuridica === 'Cooperativa'} onChange={e => setFormulario({ ...formulario, formaJuridica: e.target.checked ? 'Cooperativa' : '' })} />
                <FormControlLabel control={<Checkbox />} label="Asociación Civil" checked={formulario.formaJuridica === 'Asociación Civil'} onChange={e => setFormulario({ ...formulario, formaJuridica: e.target.checked ? 'Asociación Civil' : '' })} />
                <Box display="flex" alignItems="center">
                    <FormControlLabel control={<Checkbox />} label="Otra:" checked={formulario.formaJuridica === 'Otra'} onChange={e => setFormulario({ ...formulario, formaJuridica: e.target.checked ? 'Otra' : '' })} />
                    <TextField size="small" inputProps={{ maxLength: 50 }} />
                </Box>
            </FormGroup>


            <Typography variant="h6">3. Información del Espacio</Typography>
            <Typography variant="body1">Tipo del espacio*</Typography>
            <FormGroup>
                <FormControlLabel control={<Checkbox />} label="Patios Gastronómicos" checked={formulario.rubro === 'Patios Gastronómicos'} onChange={e => setFormulario({ ...formulario, rubro: e.target.checked ? 'Patios Gastronómicos' : '' })} />
                <FormControlLabel control={<Checkbox />} label="Food Truck, Carrobar y Afines" checked={formulario.rubro === 'Food Truck, Carrobar y Afines'} onChange={e => setFormulario({ ...formulario, rubro: e.target.checked ? 'Food Truck, Carrobar y Afines' : '' })} />
                <FormControlLabel control={<Checkbox />} label="Pancheras" checked={formulario.rubro === 'Pancheras'} onChange={e => setFormulario({ ...formulario, rubro: e.target.checked ? 'Pancheras' : '' })} />
                <FormControlLabel control={<Checkbox />} label="Concesionarias" checked={formulario.rubro === 'Concesionarias'} onChange={e => setFormulario({ ...formulario, rubro: e.target.checked ? 'Concesionarias' : '' })} />
                <FormControlLabel control={<Checkbox />} label="Stands Comerciales, Industriales y de Servicios Afines" checked={formulario.rubro === 'Stands Comerciales, Industriales y de Servicios Afines'} onChange={e => setFormulario({ ...formulario, rubro: e.target.checked ? 'Stands Comerciales, Industriales y de Servicios Afines' : '' })} />
                <FormControlLabel control={<Checkbox />} label="Sectores Recreativos de Entretenimiento y Ocio" checked={formulario.rubro === 'Sectores Recreativos de Entretenimiento y Ocio'} onChange={e => setFormulario({ ...formulario, rubro: e.target.checked ? 'Sectores Recreativos de Entretenimiento y Ocio' : '' })} />
                <FormControlLabel control={<Checkbox />} label="Ferias Privadas, Emprendedurismo y Otros" checked={formulario.rubro === 'Ferias Privadas, Emprendedurismo y Otros'} onChange={e => setFormulario({ ...formulario, rubro: e.target.checked ? 'Ferias Privadas, Emprendedurismo y Otros' : '' })} />
                <FormControlLabel control={<Checkbox />} label="Instituciones Estatales, Asociaciones Civiles y Sin Fines de Lucro" checked={formulario.rubro === 'Instituciones Estatales, Asociaciones Civiles y Sin Fines de Lucro'} onChange={e => setFormulario({ ...formulario, rubro: e.target.checked ? 'Instituciones Estatales, Asociaciones Civiles y Sin Fines de Lucro' : '' })} />
            </FormGroup>
            <TextField label="Dimensiones de los puestos, food trucks, estructuras o similares*"
                rows={4} multiline
                inputProps={{ maxLength: 100 }} value={formulario.dimensiones} onChange={e => setFormulario({ ...formulario, dimensiones: e.target.value })} />
            <TextField label="Tipo de Autoabastecimiento Energético*"
                rows={4} multiline
                inputProps={{ maxLength: 100 }} value={formulario.autoabastecimiento} onChange={e => setFormulario({ ...formulario, autoabastecimiento: e.target.value })} />
            <TextField label="Cantidad estimada de lugares para sentarse y distribución*"
                rows={4} multiline
                inputProps={{ maxLength: 200 }} value={formulario.cantidadEstimada} onChange={e => setFormulario({ ...formulario, cantidadEstimada: e.target.value })} />


            <Typography variant="h6">4. Ubicación del Espacio</Typography>
            <TextField label="Principal*" value={formulario.ubicacion.principal} onChange={e => {
                if (isNaN(e.target.value)) {
                    return;
                }

                setFormulario({ ...formulario, ubicacion: { ...formulario.ubicacion, principal: e.target.value } });
            }}
            />
            <TextField label="Secundario*" value={formulario.ubicacion.secundario} onChange={e => {
                if (isNaN(e.target.value)) {
                    return;
                }

                setFormulario({ ...formulario, ubicacion: { ...formulario.ubicacion, secundario: e.target.value } });
            }}
            />
            <Typography variant="h6">5. Redes Sociales</Typography>
            <TextField label="Instagram" placeholder="https://instagram.com/usuario" value={formulario.redesSociales.instagram} onChange={e => setFormulario({ ...formulario, redesSociales: { ...formulario.redesSociales, instagram: e.target.value } })} />
            <TextField label="Facebook" placeholder="https://facebook.com/usuario" value={formulario.redesSociales.facebook} onChange={e => setFormulario({ ...formulario, redesSociales: { ...formulario.redesSociales, facebook: e.target.value } })} />
            <TextField label="Otra Red Social" placeholder="https://otra.com/usuario" value={formulario.redesSociales.otra} onChange={e => setFormulario({ ...formulario, redesSociales: { ...formulario.redesSociales, otra: e.target.value } })} />

            <Typography variant="h6">6. Otra Información (de corresponder)</Typography>
            <Typography>Logotipo (PNG o JPG)*:</Typography>
            <TextField type="file" inputProps={{ accept: '.png,.jpg', multiple: true }} onChange={e => setFormulario({ ...formulario, logotipo: e.target.files })} />
            <Typography>Nota de Oferta Gastronómica(PDF):</Typography>
            <TextField type="file" inputProps={{ accept: '.pdf' }} onChange={e => setFormulario({ ...formulario, notaOferta: e.target.files })} />
            <Typography>Vehículos y Mobiliario(solo concesionarias) (PDF):</Typography>
            <TextField type="file" inputProps={{ accept: '.pdf' }} onChange={e => setFormulario({ ...formulario, vehiculos: e.target.files })} />
            <Typography>Descripción de Juegos Mecanicos, inflables, similares (solo espacios recreativos) (PDF):</Typography>
            <TextField type="file" inputProps={{ accept: '.pdf' }} onChange={e => setFormulario({ ...formulario, juegos: e.target.files })} />
            <Typography>Inscripción Registral (PDF):</Typography>
            <TextField type="file" inputProps={{ accept: '.pdf' }} onChange={e => setFormulario({ ...formulario, registral: e.target.files })} />

            <Typography variant="h6">7. Documentación Adjunta</Typography>
            <Typography>Constancia de Inscripción en ARCA (PDF)*:</Typography>
            <TextField type="file" inputProps={{ accept: '.pdf' }} onChange={e => setFormulario({ ...formulario, arca: e.target.files })} />
            <Typography>Constancia de Ingresos Brutos en DGR (PDF)*:</Typography>
            <TextField type="file" inputProps={{ accept: '.pdf' }} onChange={e => setFormulario({ ...formulario, ingresosBrutos: e.target.files })} />
            <Typography>Alta de Comercio Municipal (PDF):</Typography>
            <TextField type="file" inputProps={{ accept: '.pdf' }} onChange={e => setFormulario({ ...formulario, tasaComercio: e.target.files })} />
            <Typography>Libre de Deuda Municipalidad de Villa María (PDF):</Typography>
            <TextField type="file" inputProps={{ accept: '.pdf' }} onChange={e => setFormulario({ ...formulario, libreDeuda: e.target.files })} />
            {canEdit &&
                <Button variant="contained" type="submit"
                    onClick={handleSubmit}
                >Enviar</Button>
            }
        </Box>
    );
}